import {
  DEFAULT_DATE_FORMAT_WITH_TIME,
  dateISOStringToFormat,
} from 'helpers/formatters/date';
import {
  DifferenceValue,
  DifferenceWrapper,
  Link,
} from './PerformanceReturnsStyles';
import Positive from 'components/Icons/Positive';
import Negative from 'components/Icons/Negative';
import { formatToPercent } from 'helpers/formatters/number';
import { Stream } from 'types/PerformanceReturns';

export const getPerformanceReturnColumns = (
  drillDownHandler?: (date: string) => void
) => [
  {
    Header: 'Month End',
    accessor: 'date',
    testid: 'date',
    Cell: (row: any) => (
      <Link onClick={() => drillDownHandler?.(row.value)}>
        {dateISOStringToFormat(row.value)}
      </Link>
    ),
  },
  {
    Header: 'Monthly Return',
    accessor: 'value',
    testid: 'value',
    className: 'text-right',
    Cell: (row: any) => (
      <div className='text-right'>{formatToPercent(row.value)}</div>
    ),
  },
];

export const getPerformanceReturnCompareColumns = (
  stream: Stream,
  streamCompare: Stream,
  drillDownHandler?: (date: string) => void
) => [
  {
    Header: 'Month End',
    accessor: 'date',
    testid: 'date',
    Cell: (row: any) => (
      <Link onClick={() => drillDownHandler?.(row.value)}>
        {dateISOStringToFormat(row.value)}
      </Link>
    ),
  },
  {
    Header: `Monthly Return on ${dateISOStringToFormat(
      stream.dateCreated,
      DEFAULT_DATE_FORMAT_WITH_TIME
    )}`,
    accessor: 'value',
    testid: 'value',
    className: 'text-right',
    Cell: (row: any) => (
      <div className='text-right'>{formatToPercent(row.value)}</div>
    ),
  },
  {
    Header: `Monthly Return on ${dateISOStringToFormat(
      streamCompare.dateCreated,
      DEFAULT_DATE_FORMAT_WITH_TIME
    )}`,
    accessor: 'valueCompare',
    testid: 'valueCompare',
    className: 'text-right',
    Cell: (row: any) => (
      <div className='text-right'>{formatToPercent(row.value)}</div>
    ),
  },
  {
    Header: 'Monthly Return Difference',
    accessor: 'difference',
    testid: 'difference',
    className: 'text-right',
    Cell: (row: any) => (
      <DifferenceWrapper>
        {row.value > 0 ? <Positive /> : row.value < 0 ? <Negative /> : null}
        <DifferenceValue>{formatToPercent(row.value)}</DifferenceValue>
      </DifferenceWrapper>
    ),
  },
];
